import { CoachingStreakView } from '@euler/model/coaching-progress';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useRef, useState } from 'react';

/** The trainee's streak and this week's goal, with the goal editable. */
export function useCoachingStreak() {
  const { coachingService } = useServiceFactory();
  const [streak, setStreak] = useState<CoachingStreakView | null>(null);
  const [failed, setFailed] = useState(false);
  const [saving, setSaving] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey(k => k + 1), []);
  useEffect(() => {
    let active = true;
    coachingService
      .getStreak()
      .then(value => {
        if (!active) return;
        setStreak(value);
        setFailed(false);
      })
      .catch(error => {
        console.error('coaching streak failed', error);
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [coachingService, reloadKey]);
  const inFlight = useRef(false);
  const setGoal = useCallback(
    async (weeklyGoal: number) => {
      if (inFlight.current) return false;
      inFlight.current = true;
      setSaving(true);
      try {
        setStreak(await coachingService.setWeeklyGoal(weeklyGoal));
        return true;
      } catch (error) {
        console.error('coaching weekly goal failed', error);
        return false;
      } finally {
        inFlight.current = false;
        setSaving(false);
      }
    },
    [coachingService],
  );
  return { streak, failed, saving, reload, setGoal };
}
